import SvgIcon, { SvgIconProps } from "./SvgIcon";

const UmbrellaIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.04772 12.4243C4.65622 12.4784 5.18862 12.5675 5.68999 12.7176C6.27732 12.8934 6.7957 13.145 7.33107 13.4883C9.07959 12.8358 10.5224 12.4917 11.9957 12.4951C13.4653 12.4984 14.9054 12.8474 16.648 13.4862C17.2248 13.0991 17.7687 12.8305 18.3727 12.6563C18.8665 12.5138 19.3792 12.4409 19.9502 12.4041C19.577 8.3413 16.16 5.15954 11.9999 5.15954C7.83283 5.15954 4.4114 8.35183 4.04772 12.4243ZM2.47559 13.1437C2.47559 7.88354 6.73976 3.61938 11.9999 3.61938C17.26 3.61938 21.5242 7.88354 21.5242 13.1437C21.5242 13.5635 21.1878 13.906 20.7681 13.9137C19.9011 13.9295 19.3132 13.9879 18.7996 14.1361C18.2981 14.2807 17.8236 14.524 17.2134 14.9709C17.0027 15.1252 16.7284 15.1622 16.4844 15.0694C14.6383 14.3666 13.2978 14.0382 11.9923 14.0352C10.6884 14.0323 9.35057 14.3538 7.51134 15.0676C7.2717 15.1606 7.00146 15.1279 6.79093 14.9804C6.2248 14.5838 5.76254 14.347 5.24828 14.1931C4.72352 14.036 4.10624 13.9535 3.21083 13.9129C2.79949 13.8944 2.47559 13.5554 2.47559 13.1437Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1495 7.55961C14.5308 7.37126 14.9926 7.52771 15.181 7.90905C15.5242 8.60408 15.8385 9.44189 16.0343 10.4154C16.1182 10.8324 15.8482 11.2384 15.4312 11.3223C15.0142 11.4062 14.6082 11.1361 14.5244 10.7192C14.3578 9.89116 14.0909 9.18005 13.8001 8.59107C13.6116 8.20975 13.7681 7.74794 14.1495 7.55961Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85152 7.55961C9.47017 7.37126 9.00839 7.52771 8.82005 7.90905C8.47678 8.60408 8.16253 9.44189 7.96669 10.4154C7.88281 10.8324 8.15283 11.2384 8.56979 11.3223C8.98674 11.4062 9.39276 11.1361 9.47664 10.7192C9.64319 9.89116 9.91004 9.18005 10.2009 8.59107C10.3893 8.20975 10.2329 7.74794 9.85152 7.55961Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0004 12.5124C12.4257 12.5124 12.7705 12.8572 12.7705 13.2825V19.5441C12.7705 20.9128 11.661 22.0223 10.2923 22.0223C8.92353 22.0223 7.81396 20.9128 7.81396 19.5441V19.228C7.81396 18.8028 8.15875 18.458 8.58405 18.458C9.00935 18.458 9.35412 18.8028 9.35412 19.228V19.5441C9.35412 20.0622 9.77417 20.4821 10.2923 20.4821C10.8104 20.4821 11.2303 20.0622 11.2303 19.5441V13.2825C11.2303 12.8572 11.5751 12.5124 12.0004 12.5124Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0003 2C12.4256 2 12.7704 2.34478 12.7704 2.77008V4.38964C12.7704 4.81495 12.4256 5.15972 12.0003 5.15972C11.5749 5.15972 11.2302 4.81495 11.2302 4.38964V2.77008C11.2302 2.34478 11.5749 2 12.0003 2Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </SvgIcon>
  );
};

export default UmbrellaIcon;
